import { Component, Input } from '@angular/core';
import { UICallHistoryItem } from '../../../models/company-call-history/company-call-history.model';
import { TranslateService } from '@ngx-translate/core';
@Component({
  selector: 'sms-call-details',
  templateUrl: './sms-call-details.component.html',
  styleUrls: [
  './sms-call-details.component.scss',
  '../company-call-history-common-list-style.scss'
  ]
  })

export class SmsCallDetailsComponent {

  public dateFormat = 'MM/dd/yy HH:mm';
  public locale: string;
  @Input() callItem: UICallHistoryItem;
  constructor(
    private translate: TranslateService
  ) { }
  ngOnInit(): void {
    this.locale = `${this.translate.currentLang}-${this.translate.currentLang?.toLowerCase()}`;
  } 
}